// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 712 ? "micromag-container" : chunkId) + "." + {"712":"2e86f91d","892":"84224d10"}[chunkId] + ".chunk.css";
};